import React, {useEffect, useRef} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import useQueryNewsList from '../../hooks/api/news/useQueryNewsList'
import TableHeader from '../../components/table/TableHeader'
import Text from '../../components/text/Text'
import TableLayout from '../../components/table/TableLayout'
import TableItem from '../../components/table/TableItem'
import WizImage from '../../components/image/WizImage'
import {useImage} from '../../utils/image'
import WizButton from '../../components/button/WizButton'
import UploadNewsModal from '../../features/page/news/UploadNewsModal'

interface IProps {
    className?: string
}

const NewsPage: React.FC<IProps> = ({className}) => {
    const {renderThumbnail} = useImage()

    const {data, refetch} = useQueryNewsList()

    const convertDeadline = (create_at?: number) => {
        if (!create_at) return ''

        const getDayTime = 1000 * 60 * 60 * 24
        const deadline = new Date(create_at * 1000 + getDayTime * 3)
        const renderDeadlineColor = () => {
            if (deadline.getTime() - new Date(create_at * 1000).getTime() < getDayTime) {
                return 'text-ti2 text-font_red'
            }
        }

        return <Text className={`${renderDeadlineColor()}`}>{deadline.toLocaleDateString()}</Text>
    }

    const uploadModalRef = useRef<any>()

    const onClickUpload = list => {
        uploadModalRef?.current?.show(list)
    }

    useEffect(() => {
        refetch()
    }, [data])

    return (
        <PageLayout title={'News'}>
            <TableHeader className={'grid-cols-[120px_1fr_200px_80px_80px_80px] space-x-[30px] md:hidden'}>
                <Text>Thumbnail</Text>
                <Text>Title</Text>
                <Text className={'text-center'}>Writer</Text>
                <Text className={'text-center'}>Deadline</Text>
                <Text className={'text-center'}>Link</Text>
                <Text className={'text-center'}>View</Text>
            </TableHeader>
            <TableLayout>
                {data?.map(list => (
                    <TableItem
                        key={list?.id}
                        className={
                            'grid-cols-[120px_1fr_200px_80px_80px_80px] lg:grid-cols-[120px_1fr_200px_80px_80px_80px] md:grid-cols-3 space-x-[30px] lg:space-x-0 lg:gap-x-[10px] md:gap-y-[20px] sm:block sm:space-y-[15px]'
                        }>
                        <div>
                            <WizImage
                                src={list?.thumbnail}
                                className={'w-[120px] rounded-[10px] md:w-[200px] sm:mx-auto'}
                            />
                        </div>
                        <div className={'flex items-center justify-between lg:gap-x-[10px] md:col-span-2 sm:block '}>
                            <Text
                                className={
                                    'flex-1 text-ti2 md:text-ti1 sm:text-center sm:py-[15px] sm:pb-[15px] sm:break-keep'
                                }>
                                {list?.title}
                            </Text>
                            <div className={'sm:w-min sm:mx-auto'}>
                                <WizButton
                                    size={'small'}
                                    type={'blue'}
                                    onClick={() => onClickUpload(list)}
                                    text={'Upload'}
                                />
                            </div>
                        </div>
                        <div className={'flex space-x-[10px] items-center justify-start md:hidden'}>
                            <WizImage src={renderThumbnail(list?.owner?.thumbnail)} className={'w-[40px]'} />
                            <Text>{list?.owner?.name}</Text>
                        </div>
                        <div className={'text-center'}>
                            <Text className={'hidden md:block md:text-ti3 md:text-font03 md:pb-[5px]'}>Create At</Text>
                            {convertDeadline(list?.created_at)}
                        </div>
                        <div className={'text-center'}>
                            <Text className={'hidden md:block md:text-ti3 md:text-font03 md:pb-[5px]'}>Link</Text>
                            <WizButton onClick={() => window.open(list?.link)} text={'Link'} type={'primary'} />
                        </div>
                        <div>
                            <Text className={'hidden md:block md:text-ti3 md:text-font03 md:pb-[5px] md:text-center'}>
                                View
                            </Text>
                            <Text className={'text-center'}>{list?.is_active ? 'View' : 'Non-View'}</Text>
                        </div>
                    </TableItem>
                ))}

                {!data?.length && (
                    <TableItem className={'text-center'}>
                        <div>
                            <Text>No Items</Text>
                        </div>
                    </TableItem>
                )}
                <UploadNewsModal ref={uploadModalRef} refetch={refetch} />
            </TableLayout>
        </PageLayout>
    )
}

export default NewsPage
